// @owner ClientPlatform
/* eslint-disable jsx-a11y/label-has-associated-control */

import type {FC, PropsWithChildren} from 'react';
import React from 'react';
import type {SwitchToSigninPage} from '../../helpers/pageHelpers';
import {SigninPage} from '../../helpers/pageHelpers';
import {AuthCard} from '../../components/authCard/authCard';
import {FullWidthButton} from '../../../common/components/button';

interface PasswordResentProps {
  forgotEmail: string;
  switchToSigninPage: SwitchToSigninPage;
}

export const PasswordResent: FC<PropsWithChildren<PasswordResentProps>> = ({forgotEmail, switchToSigninPage}) => {
  return (
    <AuthCard name="forgotPasswordform">
      <p>
        If the email <a href={`mailto:${forgotEmail}`}>{forgotEmail}</a> exists, you will receive a password recovery
        link within a few minutes.
      </p>
      <FullWidthButton type="button" onClick={() => switchToSigninPage(SigninPage.LOGIN)}>
        Back to login
      </FullWidthButton>
    </AuthCard>
  );
};
